module.exports = __webpack_public_path__ + "img/phantom-hourglass.1e6fb33e.jpg";